import React, { useState, useEffect } from "react";
import {
  Table,
  Empty,
  Popconfirm,
  notification,
  Col,
  Tooltip,
  Row,
  Drawer,
  Button,
  Tabs,
  message,
} from "antd";
import { Link } from "react-router-dom";
import {
  BarsOutlined,
  PlusOutlined,
  EditOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  WarningOutlined,
  CloseCircleOutlined,
  SyncOutlined,
  MenuUnfoldOutlined,
  FileExcelOutlined,
  CopyOutlined,
} from "@ant-design/icons";
import config from "../../util/ApiforContext";
import FirmUpdate from "../Forms/FirmUpdate";
import { odata } from "../Filters/Helper";
import FirmAddForm from "../Forms/FirmAddForm";
import { RowHelper } from "util/TableHelper";
import RequestHandler from "util/RequestHandler";
import FirmListTableFilter from "../Filters/FirmListTableFilter";
import { ColumnHelper } from "../../util/TableHelper";
const { TabPane } = Tabs;

const FirmList = () => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 50,
    current: 1,
    filter: "",
    activeTab: "1",
  });
  const [order, setOrder] = useState("");

  const [firmTypeDropdown, setFirmTypeDropdown] = useState([]);
  const [wordList, setWordList] = useState([]);
  const [firmClassDropdown, setFirmClassDropdown] = useState([]);
  const [firmIdUpdate, setFirmIdUpdate] = useState("");
  const [Name, setName] = useState("");
  const [DirectiveName, setDirectiveName] = useState("");
  const [Email, setEmail] = useState("");
  const [ErpSalesCode, setErpSalesCode] = useState("");
  const [NetCollecPlasiyerCode, setNetCollecPlasiyerCode] = useState("");
  const [PurchaseType, setPurchaseType] = useState("");
  const [CustomerType, setCustomerType] = useState("");
  const [PlaceType, setPlaceType] = useState("");
  const [Division, setDivision] = useState();
  const [Deparment, setDeparment] = useState();

  const [City, setCity] = useState("");
  const [Town, setTown] = useState("");
  const [SpecialCode, setSpecialCode] = useState("");
  const [AuthorizationCode, setAuthorizationCode] = useState("");
  const [AccountCode, setAccountCode] = useState("");
  const [TaxOffice, setTaxOffice] = useState("");
  const [groupCode, setGroupCode] = useState("");
  const [Vkn, setVkn] = useState("");
  const [TcNo, setTcNo] = useState("");
  const [Phone, setPhone] = useState("");
  const [MobilePhone, setMobilePhone] = useState("");
  const [Fax, setFax] = useState("");
  const [Address, setAddress] = useState("");
  const [FirmTypeValue, setFirmTypeValue] = useState("");
  const [ErpCode, setErpCode] = useState("");
  const [AccountingCode, setAccountingCode] = useState("");
  const [FirmBranchNumberUpdate, setFirmBranchNumberUpdate] = useState("");
  const [FirmClassId, setFirmClassId] = useState("");
  const [TransactionProjectTypeId, setTransactionProjectTypeId] = useState("");

  const [isUseB2B, setIsUseB2B] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleUpdate, setVisibleUpdate] = useState(false);
  const [totalFirmCount, setTotalFirmCount] = useState("");
  const [chequeControl, setChequeControl] = useState();
  const [syncButton, setSyncButton] = useState({
    visible: false,
    loading: false,
  });
  const [lastQueryBalanceDate, setLastQueryBalanceDate] = useState("");
  const [IsGroup, setIsGroup] = useState(false);
  const [showSalesCode, setShowSalesCode] = useState(false);
  const [showFirmTitle, setShowFirmTitle] = useState(false);
  const [baseUrl, setBaseUrl] = useState("");

  useEffect(() => {
    RequestHandler.get(`/Firm/GetFirmType`).then((response) => {
      setFirmTypeDropdown(response.data);
    });
    RequestHandler.get(`/FirmClass`).then((response) => {
      setFirmClassDropdown(response.value);
    });
    RequestHandler.get("/TenantErpProgram/IsHaveTenantSyncRole").then(
      (response) => {
        if (response) {
          setSyncButton({ ...syncButton, visible: true });
        }
      }
    );

    RequestHandler.get(`/Firm/GetLastQueryDateBalance`).then((response) => {
      setLastQueryBalanceDate(response);
    });
    RequestHandler.get(
      `/FirmClass?$count=true&$filter=ParentFirmClassName eq 'Cek'`
    ).then((response) => {
      setChequeControl(response["@odata.count"] > 0 ? true : false);
      RequestHandler.get(
        `/Firm/TotalFirmCount?tab=${response["@odata.count"] > 0 ? 1 : 0}`
      ).then((response) => {
        setTotalFirmCount(response);
      });
    });

    getTenantUserParameter();
    getPageSettings();
  }, []);

  useEffect(
    () => getTableData(),
    [order, tableDataQueryOptions, chequeControl]
  );

  useEffect(() => {
    const baseUrl = `${window.location.protocol}//${window.location.hostname}${
      window.location.port ? `:${window.location.port}` : ""
    }`;
    setBaseUrl(baseUrl);
  }, []);

  const getFilterQuery = () => {
    let query = "$filter=";
    const { filter, activeTab } = tableDataQueryOptions;
    const conditions = ["Name ne 'Diğer'"];
    if (filter) {
      conditions.push(filter);
    }
    switch (activeTab) {
      case "1":
        query += chequeControl
          ? "(parentFirmClassName eq 'Cari' or parentFirmClassName eq null) and"
          : "";
        break;
      case "2":
        query += "parentFirmClassName eq 'Banka' and";
        break;
      case "3":
        query += "parentFirmClassName eq 'Masraf' and";
        break;
      case "4":
        query += "parentFirmClassName eq 'Cek' and";
        break;
      case "5":
        query += "parentFirmClassName eq 'Senet' and";
        break;
    }

    if (conditions.length > 0) query += `  ${conditions.join(" and ")}`;
    return query;
  };

  const getTableData = () => {
    if (chequeControl == undefined) return;
    setSelectedRowKeys([]);
    setTableData({
      ...tableData,
      loading: true,
    });

    const { skip, take } = tableDataQueryOptions;

    RequestHandler.get(
      `/Firm?$count=true&${getFilterQuery()}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      if (Array.isArray(response.value)) {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      }
    });
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setOrder(orderBy);
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };
  const onTabChange = (tabKey) => {
    RequestHandler.get(`/Firm/TotalFirmCount?tab=${tabKey}`).then(
      (response) => {
        setTotalFirmCount(response);
      }
    );
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      activeTab: tabKey,
    });
  };
  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return {
        skip: 0,
        current: 1,
        take: prevState.take,
        filter: query,
        activeTab: prevState.activeTab,
      };
    });
  };

  const showDrawerUpdate = (id) => {
    RequestHandler.get(`/Firm/GetById/${id}`).then((response) => {
      setName(response.name);
      setDirectiveName(response.directiveName);
      setEmail(response.email);
      setErpSalesCode(response.erpSalesCode);
      setNetCollecPlasiyerCode(response.netCollecPlasiyerCode);
      setPurchaseType(response.purchaseType);
      setPlaceType(response.placeType);
      setDivision(response.divisionId);
      setDeparment(response.deparmentId);
      setCustomerType(response.customerType);
      setTaxOffice(response.taxOffice);
      setCity(response.city);
      setTown(response.town);
      setSpecialCode(response.specialCode);
      setAuthorizationCode(response.authorizationCode);
      setAccountCode(response.accountCode);
      setGroupCode(response.groupCode);
      setVkn(response.vkn);
      setTcNo(response.tcNo);
      setPhone(response.phone == null ? "          " : response.phone);
      setMobilePhone(
        response.mobilePhone == null ? "          " : response.mobilePhone
      );
      setFax(response.fax);
      setAddress(response.address);
      setErpCode(response.erpCode);
      setFirmTypeValue(response.firmTypeValue.toString());
      setFirmBranchNumberUpdate(response.firmBranchNumber);
      setFirmClassId(response.firmClassId);
      setTransactionProjectTypeId(response.transactionProjectTypeId);

      setFirmIdUpdate(id);
      setVisibleUpdate(true);
      setAccountingCode(response.accountingCode);
      setIsGroup(response.isGroup);
    });

    RequestHandler.get(`/Firm/GetMathingWordWithFirmId/${id}`).then((res) => {
      setWordList(res);
    });
  };

  const onClose = () => {
    setVisible(false);
  };
  const onCloseUpdate = () => {
    setVisibleUpdate(false);
  };

  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "Uyarı",
      description: "Pasif olan firmalar güncellenemez.",
    });
  };

  const handleActivePassive = (id) => {
    RequestHandler.delete(`/Firm?id=${id}`).then((res) => {
      if (res.success) {
        getTableData();
      }
    });
  };

  const getData = (val) => {
    if (val === "success") {
      getTableData();
      setVisibleUpdate(false);
      setVisible(false);
    }
  };

  const onConfirmSyncFirms = async () => {
    setSyncButton({ ...syncButton, loading: true });
    const url = pageSettings?.isFinekraLogo
      ? `${config.isFinekraLogoApiUrl}/FirmSync`
      : "/ErpReport/SyncFirm";

    const response = await (pageSettings?.isFinekraLogo
      ? RequestHandler.post(url, { TenantId: pageSettings?.tenantId })
      : RequestHandler.get(url));

    setSyncButton({ ...syncButton, loading: false });

    if (response) {
      getTableData();
      const totalFirms = await RequestHandler.get(
        `/Firm/TotalFirmCount?tab=${tableDataQueryOptions.activeTab}`
      );
      setTotalFirmCount(totalFirms);
      notification.success({ message: "Senkronizasyon işlemi başarılı." });
    } else {
      notification.error({ message: "Senkronizasyon işlemi başarısız." });
    }
  };

  const getTenantUserParameter = () => {
    RequestHandler.get(`/TenantUserParameter/GetDigitParameter`).then(
      (response) => {
        if (response.success) {
          setShowSalesCode(response.data.showSalesCodeInFirmTable);
          setShowFirmTitle(response.data.isShowFirmTitle);
        }
      }
    );
  };
  const onClickExportExcel = () => {
    const hideMessage = message.loading("Excel indiriliyor...", 0);

    const { activeTab } = tableDataQueryOptions;
    RequestHandler.post(
      `/Firm/ExportExcel`,
      {
        query: getFilterQuery(),
      },
      false
    ).then((response) => {
      hideMessage();
      if (response.success) {
        if (response) {
          window.open(
            `${config.apiUrl}/Firm/DownloadExcel?fileName=${
              response.message
            }&tab=${activeTab}&t=${RequestHandler.getToken()}`
          );
        }
      } else
        notification.error({
          message: response.message,
          duration: 3,
        });
    });
  };

  const UpperCaseTurkish = (str) => {
    const lower = "iıüğşöç";
    const upper = "İIÜĞŞÖÇ";

    return str.replace(/./g, (char) => {
      const index = lower.indexOf(char);
      return index !== -1 ? upper[index] : char.toUpperCase();
    });
  };
  const ScreenNameWithActiveTab = () => {
    switch (tableDataQueryOptions.activeTab) {
      case "1":
        return "Cari";
      case "2":
        return "Banka";
      case "3":
        return "Masraf";
      case "4":
        return "Çek";
      case "5":
        return "Senet";
    }
  };
  const columns = [
    {
      title: `${ScreenNameWithActiveTab()} Adı`,
      dataIndex: "name",
      key: "name",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 22).length < 22
              ? text.substring(0, 22) + ""
              : text.substring(0, 22) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: `${ScreenNameWithActiveTab()} Kodu`,
      dataIndex: "firmBranchNumber",
      key: "firmBranchNumber",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 22).length < 22
              ? text.substring(0, 22) + ""
              : text.substring(0, 22) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Tckn / Vkn",
      dataIndex: "tcNo",
      align: "center",
      key: "vknTckn",
      render: (_, row) => {
        return row.tcNo === null || row.tcNo == ""
          ? row.vkn === null || row.vkn == ""
            ? "-"
            : row.vkn
          : row.tcNo;
      },
    },
    {
      title: `${ScreenNameWithActiveTab()} Tipi`,
      dataIndex: "firmTypeValue",
      align: "center",
      key: "firmTypeValue",
    },
    !showSalesCode
      ? {}
      : {
          title: "Satıcı Kodu",
          render: (text, data) => {
            return pageSettings?.erpProgramId !== 9
              ? data.erpSalesCode
              : data.netCollecPlasiyerCode;
          },
        },
    isUseB2B
      ? {
          title: "Ödeme Seti Adı",
          align: "center",
          dataIndex: "paymentSetName",
        }
      : {},
    isUseB2B
      ? {
          title: "Ödeme Linki Kopyala",
          dataIndex: "copyLink",
          align: "center",
          render: (data, row) => (
            <a
              onClick={() => {
                copyToLink(row.constantPaymentLink, row.id);
              }}
            >
              <CopyOutlined style={{ fontSize: "130%" }} />
            </a>
          ),
        }
      : {},
    {
      title: (
        <Tooltip
          title={`Son Sorgulama Tarihi: ${lastQueryBalanceDate}`}
          style={{ width: "%100" }}
        >
          Bakiye
        </Tooltip>
      ),
      dataIndex: "balance",
      key: "balance",
      align: "right",
      render: (data) => {
        if (data === null) return "-";
        return ColumnHelper.renderDecimal(data);
      },
    },
    {
      title: "Durum",
      dataIndex: "operation",
      align: "center",
      render: (_, record) =>
        record.isActive ? (
          <Popconfirm
            title="Pasif yapmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleActivePassive(record.id)}
          >
            <a style={{ color: "green", fontSize: "130%" }}>
              <CheckCircleOutlined />
            </a>
          </Popconfirm>
        ) : (
          <Popconfirm
            title="Aktif yapmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleActivePassive(record.id)}
          >
            <a style={{ color: "red", fontSize: "130%" }}>
              <CloseCircleOutlined />
            </a>
          </Popconfirm>
        ),
    },
    {
      title: "Logo Aktarım Durumu",
      dataIndex: "transferStatus",
      align: "center",
      render: (transferStatus, record) => {
        if (transferStatus === 1) {
          return (
            <a style={{ color: "green", fontSize: "130%" }}>
              <Tooltip title="Logo'ya Kaydı Başarılı">
                <CheckCircleOutlined />
              </Tooltip>
            </a>
          );
        } else if (transferStatus === 2) {
          return (
            <a style={{ color: "blue", fontSize: "130%" }}>
              <Tooltip title="Logo'ya Kaydı Yapılıyor">
                <ClockCircleOutlined />
              </Tooltip>
            </a>
          );
        } else if (transferStatus === 3) {
          return (
            <a style={{ color: "red", fontSize: "130%" }}>
              <Tooltip title={record.sendFirmError}>
                <WarningOutlined />
              </Tooltip>
            </a>
          );
        }
        return null;
      },
    },
    {
      title: "Düzenle",
      dataIndex: "operation",
      align: "center",
      width: "1%",
      render: (_, record) =>
        record.isActive ? (
          <a
            onClick={() => {
              showDrawerUpdate(record.id);
            }}
            style={{ color: "orange", fontSize: "130%" }}
          >
            <EditOutlined />
          </a>
        ) : (
          <a
            onClick={() => {
              openNotificationWithIcon("warning");
            }}
            style={{ color: "orange", fontSize: "130%" }}
          >
            <EditOutlined />
          </a>
        ),
    },
    {
      title: "Hesaplar",
      dataIndex: "",
      align: "center",
      render: (record) => {
        return (
          <Link
            style={{ fontSize: "150%" }}
            to={`/firm-account-list/${record.id}`}
          >
            <MenuUnfoldOutlined />
          </Link>
        );
      },
    },
  ];

  const renderDetailString = (text) => (text ? text : "-");
  const detailColumns = [
    {
      title: "E-posta",
      dataIndex: "email",
      render: renderDetailString,
    },
    {
      title: "Vergi Dairesi",
      dataIndex: "taxOffice",
      render: renderDetailString,
    },
    {
      title: "Adres",
      dataIndex: "address",
      render: renderDetailString,
    },
    {
      title: "Fax Numarası",
      dataIndex: "fax",
      render: renderDetailString,
    },
    {
      title: "Cep Telefonu",
      dataIndex: "mobilePhone",
      render: renderDetailString,
    },
    {
      title: "Ev Telefonu",
      dataIndex: "phone",
      render: renderDetailString,
    },
    {
      title: "İl",
      dataIndex: "city",
      render: renderDetailString,
    },
    {
      title: "İlçe",
      dataIndex: "town",
      render: renderDetailString,
    },
    {
      title: "Özel Kod",
      dataIndex: "specialCode",
      render: renderDetailString,
    },
    {
      title: "Yetki Kodu",
      dataIndex: "authorizationCode",
      render: renderDetailString,
    },
    {
      title: "Hesap Kodu",
      dataIndex: "accountCode",
      render: renderDetailString,
    },
    {
      title: showSalesCode ? "" : "Satıcı Kodu",
      render: (text, data) => {
        return pageSettings?.erpProgramId !== 9
          ? data.erpSalesCode
          : data.netCollecPlasiyerCode;
      },
    },
  ];

  if (showFirmTitle) {
    detailColumns.push({
      title: "Talimat Ünvanı",
      dataIndex: "directiveName",
      render: renderDetailString,
    });
  }

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [pageSettings, setPageSettings] = useState();
  const onTableSelectChange = (selectedKeys) => {
    setSelectedRowKeys(selectedKeys);
  };

  const getPageSettings = () => {
    RequestHandler.get("/TenantErpProgram/GetByTenant").then((response) => {
      if (response) setPageSettings(response);
      else setTableData({ ...tableData, loading: false });
    });
    RequestHandler.get(`/tenantModule?$filter=moduleId eq 8`).then(
      (response) => {
        if (response.value.length > 0) setIsUseB2B(true);
      }
    );
  };

  const onSendFirmsToLogo = () => {
    const selectedRowsData = tableData.data
      .filter((row) => selectedRowKeys.includes(row.id))
      .map((row) => ({ firmId: row.id, error: row.sendFirmError }));
    RequestHandler.post("/ErpLogo/SendFirmToLogo", selectedRowsData).then(
      (response) => {
        if (response.success) {
          getTableData();
        }
      }
    );
  };

  const copyToLink = (constantPaymentLink, id) => {
    if (constantPaymentLink) {
      message.success("Link Kopyalandı.");
      navigator.clipboard.writeText(constantPaymentLink);
    } else {
      RequestHandler.post(
        `/ConstantPaymentRequest`,
        {
          FirmId: id,
        },
        true
      ).then((response) => {
        if (response.success) {
          message.success("Link Kopyalandı.");
          navigator.clipboard.writeText(
            baseUrl + "/ConstantPaymentPage?paymentGuid=" + response.message
          );
        }
      });
    }
  };

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: 10 }}>
            <BarsOutlined />{" "}
            {`${UpperCaseTurkish(ScreenNameWithActiveTab())} LİSTESİ`}
          </p>
        </Col>
        <Col xs={24} md={12} lg={7} style={{ textAlign: "right" }}>
          {syncButton.visible && (
            <Popconfirm
              title="Erp programınız ile cari senkronizasyonu tetiklemek istiyor musunuz?"
              okText="Evet"
              cancelText="Hayır"
              placement="bottom"
              disabled={syncButton.loading}
              onConfirm={onConfirmSyncFirms}
            >
              <Button
                disabled={syncButton.loading}
                loading={syncButton.loading}
                style={{ marginRight: 15 }}
              >
                <SyncOutlined /> Cari Senkronizasyonu
              </Button>
            </Popconfirm>
          )}
          <Button
            type="text"
            style={{ marginRight: 15, pointerEvents: "none", fontSize: 16 }}
          >
            Cari Sayısı: {totalFirmCount}
          </Button>
          <Button type="primary" onClick={() => setVisible(true)}>
            <PlusOutlined /> {ScreenNameWithActiveTab()} Ekle
          </Button>
          {pageSettings?.isHasSendFirmToLogo && (
            <Popconfirm
              title="Aktarmak istiyor musunuz?"
              okText="Evet"
              cancelText="Hayır"
              placement="bottom"
              disabled={selectedRowKeys.length < 1}
              onConfirm={onSendFirmsToLogo}
            >
              <Button type="primary" disabled={selectedRowKeys.length < 1}>
                <PlusOutlined /> Logo'ya Carileri Kaydet
              </Button>
            </Popconfirm>
          )}
        </Col>
        <Col xs={24} lg={1} style={{ textAlign: "right" }}>
          <Tooltip title="Excel İndir">
            <a
              style={{
                color: "green",
                fontSize: "180%",
                marginRight: 30,
              }}
              onClick={onClickExportExcel}
            >
              <FileExcelOutlined />
            </a>
          </Tooltip>
        </Col>
      </Row>
      {chequeControl && (
        <Tabs defaultActiveKey="1" onChange={onTabChange}>
          <TabPane tab="Cari" key="1"></TabPane>
          <TabPane tab="Banka" key="2"></TabPane>
          <TabPane tab="Masraf" key="3"></TabPane>
          <TabPane tab="Çek" key="4"></TabPane>
          <TabPane tab="Senet" key="5"></TabPane>
        </Tabs>
      )}

      <FirmListTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        activeTab={tableDataQueryOptions.activeTab}
        isUseB2B={isUseB2B}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Row id="tableArea">
        <Col span={24}>
          <Table
            rowSelection={
              pageSettings?.isHasSendFirmToLogo
                ? {
                    selectedRowKeys: selectedRowKeys,
                    onChange: onTableSelectChange,
                    getCheckboxProps: (record) => ({
                      disabled:
                        record.sendFirmId != null &&
                        record.sendFirmError == null,
                    }),
                  }
                : undefined
            }
            columns={
              pageSettings?.isHasSendFirmToLogo
                ? columns
                : columns.filter((ea) => ea.dataIndex !== "transferStatus")
            }
            expandable={{
              expandedRowRender: (row) =>
                RowHelper.renderRowDetail({
                  data: row,
                  columns: detailColumns,
                }),
            }}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%" }}
            rowKey="id"
            filterable={true}
            size="small"
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100", "250", "500"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
          />
        </Col>
      </Row>

      <Drawer
        title={`${ScreenNameWithActiveTab()} Ekle`}
        width={241}
        onClose={onClose}
        visible={visible}
        bodyStyle={{ paddingBottom: 80 }}
        maskClosable={false}
        footer={<div style={{ textAlign: "right" }}></div>}
      >
        <FirmAddForm
          activeTab={tableDataQueryOptions.activeTab}
          IsHasSendFirmToLogo={pageSettings?.isHasSendFirmToLogo}
          IsDivisionAndDeparment={pageSettings?.isDivisionAndDeparment}
          ErpProgramId={pageSettings?.erpProgramId}
        />
      </Drawer>

      <Drawer
        title="Cari Güncelle"
        width={241}
        onClose={onCloseUpdate}
        visible={visibleUpdate}
        bodyStyle={{ paddingBottom: 80 }}
        footer={<div style={{ textAlign: "right" }}></div>}
      >
        <FirmUpdate
          firmId={firmIdUpdate}
          Name={Name}
          DirectiveName={DirectiveName}
          Email={Email}
          ErpSalesCode={ErpSalesCode}
          ErpProgramId={pageSettings?.erpProgramId}
          NetCollecPlasiyerCode={NetCollecPlasiyerCode}
          City={City}
          CustomerType={CustomerType}
          PlaceType={PlaceType}
          DivisionId={Division}
          DeparmentId={Deparment}
          PurchaseType={PurchaseType}
          Town={Town}
          SpecialCode={SpecialCode}
          AccountCode={AccountCode}
          AuthorizationCode={AuthorizationCode}
          TaxOffice={TaxOffice}
          Vkn={Vkn}
          TcNo={TcNo}
          GroupCode={groupCode}
          wordList={wordList}
          Phone={Phone}
          sendDataForUpdate={getData}
          MobilePhone={MobilePhone}
          Fax={Fax}
          Address={Address}
          FirmTypeValue={FirmTypeValue}
          FirmBranchNumber={FirmBranchNumberUpdate}
          FirmClassId={FirmClassId}
          firmTypeDropdown={firmTypeDropdown}
          firmClassDropdown={firmClassDropdown}
          ErpCode={ErpCode}
          AccountingCode={AccountingCode}
          IsHasSendFirmToLogo={pageSettings?.isHasSendFirmToLogo}
          activeTab={tableDataQueryOptions.activeTab}
          TransactionProjectTypeId={TransactionProjectTypeId}
          IsDivisionAndDeparment={pageSettings?.isDivisionAndDeparment}
          IsGroup={IsGroup}
        />
      </Drawer>
    </>
  );
};

export default FirmList;
